import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';

import Typography from 'kingpin/atoms/Typography';

import V5GadgetFormContext from '../../../contexts/V5GadgetFormContext';
import Dropdown from '../../Inputs/Dropdown';
import Inputs from '../../Inputs';
import { Section } from '../../MyAccount/Profile/styles';
import Label from '../Label';
import { InputWrapper } from '../styles';

const ContentWrapper = styled.div`
  background-color: var(--color-bg-muted);
  padding: 12px;
`;

const LABEL_STEP_OPTIONS: Array<{
  label: string;
  value: number | undefined;
  subLabel?: string;
}> = [
  { label: 'Auto', value: undefined, subLabel: 'Matches the axis labels' },
  { label: 'All', value: 1, subLabel: 'A label on every bar' },
  { label: 'Every 2nd point', value: 2 },
  { label: 'Every 3rd point', value: 3 },
  { label: 'Every 4th point', value: 4 },
  { label: 'Every 5th point', value: 5 },
];

const DataLabelsInputContainer = () => {
  const {
    showDataLabels,
    setShowDataLabels,
    labelStep,
    setLabelStep,
    draftChart,
  } = useContext(V5GadgetFormContext);

  const labelStepOptions = useMemo(
    () =>
      LABEL_STEP_OPTIONS.map((opt) => ({
        label: opt.label,
        subLabel: opt.subLabel,
        isSelected: labelStep === opt.value,
        onSelected: () => setLabelStep(opt.value),
      })),
    [labelStep, setLabelStep],
  );

  if (
    draftChart &&
    (draftChart.gadgetType === 'bar' ||
      draftChart.gadgetType === 'horizontalBar' ||
      draftChart.gadgetType === 'combo' ||
      draftChart.gadgetType === 'treeMap')
  ) {
    const showLabelStep =
      !!showDataLabels && draftChart.gadgetType !== 'treeMap';

    return (
      <Section>
        <Typography.Header type="H5">Data Labels</Typography.Header>
        <ContentWrapper>
          <InputWrapper>
            <Label>Show data labels</Label>
            <Inputs.Toggle
              value={!!showDataLabels}
              onChange={setShowDataLabels}
            />
          </InputWrapper>
          {showLabelStep && (
            <InputWrapper>
              <Label>Label step</Label>
              <Dropdown options={labelStepOptions} />
            </InputWrapper>
          )}
        </ContentWrapper>
      </Section>
    );
  }
  return null;
};

export default DataLabelsInputContainer;
